import type { LogoType } from '../../types';

export const callToAction: LogoType[] = [
  {
    id: 'e29cdc1e',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo1.png',
        name: 'logo1.png',
        alt: '',
        width: 299,
        height: 267
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'aebc5e15',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo7.png',
        name: 'logo7.png',
        alt: '',
        width: 301,
        height: 299
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'ffffa064',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        name: 'logo8.png',
        alt: '',
        width: 300,
        height: 300
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'c609afb6',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo10.png',
        name: 'logo10.png',
        alt: '',
        width: 230,
        height: 298
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'ff43a602',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        name: 'logo11.png',
        alt: '',
        width: 297,
        height: 260
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '70671a6f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo13.png',
        name: 'logo13.png',
        alt: '',
        width: 300,
        height: 180
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'f27e67dc',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        name: 'logo14.png',
        alt: '',
        width: 300,
        height: 140
      }
    },
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
